import React from "react";
import {Link} from "react-router-dom";
import "./SectionMenuSuporteLink.scss";

function SectionMenuSuportLink(props) {
  return (
    <span {...props}>
      <Link to={props.link}>{props.title}</Link>
    </span>
  );
}

export default SectionMenuSuportLink;
